import { locate } from "@dhx/ts-common/html";
import { tooltip, Position } from "@dhx/ts-message";
import { truncateWord, getFileClassName, getBasis, removeItem } from "./helper";
import { FileStatus } from "./types";
import locale from "./locales/en";

export const gridTemplate = item => {
	const inProgress = item.status === FileStatus.inprogress;
	const isError = item.status === FileStatus.failed;
	const notUploaded = item.status !== FileStatus.uploaded;
	let className = "dhx_dataview-item--file__";
	switch (item.status) {
		case FileStatus.inprogress:
			className += "progress";
			break;
		case FileStatus.queue:
			className += "queue";
			break;
		case FileStatus.failed:
			className += "failed";
			break;
		default:
			className = "";
			break;
	}

	let link = "";
	let downloadName = "";
	if (item.link) {
		link = (item.downloadURL || "") + item.link;
		downloadName = link
			.split("/")
			.pop()
			.split("?")[0];
	}

	let imagePreview = "";
	if (/image/.exec(getFileClassName(item)) && item.preview) {
		if (item.image && item.image.src) {
			imagePreview = `style="background:url('${item.image.src}') center center no-repeat;background-size:cover"`;
		} else if (item.link) {
			imagePreview = `style="background:url('${link}') center center no-repeat;background-size:cover"`;
		}
	}

	return `<div class="dhx_dataview-item--file ${className}">
		<div class="dhx_dataview-item--file-type ${getFileClassName(item)}" ${imagePreview}></div>
		${
			inProgress
				? `<div class="dhx_dataview-item--progress-block">
					<div class="dhx_dataview-item--progress-value">${(item.progress * 100).toFixed(1) + "%"}</div>
					<svg xmlns="http://www.w3.org/2000/svg" class="dhx_vault-item--progress-circle" viewBox="0 0 60 60">
						<circle cx="30" cy="30" r="28" stroke-width="4" class="dhx_vault-item--progress-bar-background"></circle>
						<circle cx="30" cy="30" r="28" stroke-width="4" stroke-dasharray="175.9 175.9" stroke-dashoffset="${(1 -
							item.progress) *
							175.9}" class="active-circle dhx_vault-item--progress-bar-active"></circle>
					</svg>
				</div>`
				: `<div class="dhx_dataview-item--default-block">
					${
						isError
							? `<div class="dhx_dataview-item--error-mark dxi dxi-alert-circle"></div>`
							: notUploaded
							? `<div class="dhx_dataview-item--error-mark dxi dxi-vault"></div>`
							: `<div class="dhx_dataview-item--success-mark dxi dxi-checkbox-marked-circle"></div>`
					}
				</div>
				<div class="dhx_dataview-item--hover-block">
					<div class="dhx_dataview-item--control-block ${
						isError || notUploaded || !item.link
							? "dhx_dataview-item--control-block__withoutLink"
							: ""
					}">
						${
							!isError && !notUploaded && item.link
								? `<a href="${link}" class="dhx_dataview-item--download-btn dxi dxi-download" download="${downloadName}"></a>
									<div class="dhx_dataview-item--remove-btn dxi dxi-delete-forever"></div>`
								: `<div class="dhx_dataview-item--remove-btn dxi dxi-delete-forever"></div>`
						}
					</div>
					${
						isError
							? `<div class="dhx_dataview-item--error-text">${locale.error}</div>`
							: `<div class="dhx_dataview-item--file-size">${getBasis(item.size)}</div>`
					}
				</div>`
		}
		</div>
	<div class="dhx_dataview-item--file-name">${truncateWord(item.name)}</div>`;
};

export const listTemplate = item => {
	const isError = item.status === FileStatus.failed;
	const inProgress = item.status === FileStatus.inprogress;
	const notUploaded = item.status !== FileStatus.uploaded && !isError;

	let link = "";
	let downloadName = "";
	if (item.link) {
		link = (item.downloadURL || "") + item.link;
		downloadName = link
			.split("/")
			.pop()
			.split("?")[0];
	}

	return `<div class="dhx_list-item--icon ${notUploaded ? "dhx_list-item--queue" : ""}">
			<div class="dhx_list-item--file-type ${getFileClassName(item)}"></div>
		</div>
		<div class="dhx_list-item--content">
		${
			inProgress
				? `<div class="dhx_list-item--name">${item.value}.${item.extension}
					<p class="dhx_item--progress-value">${(item.progress * 100).toFixed(1) + "%"}</p>
				</div>`
				: `<div class="dhx_list-item--name">${item.value}.${item.extension}</div>
					${isError ? `<div class="dhx_list-item--error-info">${locale.error}</div>` : ""}
					<div class="dhx_list-item--size ${isError ? "error" : ""}">${getBasis(item.size)}</div>	
				</div>`
		}
		</div>
		${
			inProgress
				? `<div class="dhx_item--download-progress" style="width:${(item.progress * 100).toFixed(
						1
				  )}%"></div>`
				: `<div class="dhx_item--info">
					${
						isError
							? `<div class="dhx_item--error-mark dxi dxi-alert-circle"></div><div class="dhx_item--btn-remove dxi dxi-delete-forever"></div>`
							: `${
									notUploaded
										? `<div class="dhx_item--error-mark dxi dxi-vault"></div>`
										: `<div class="dhx_item--success-mark dxi dxi-checkbox-marked-circle"></div>`
							  }
							<div class="dhx_item--hover-block">
								${
									!isError && !notUploaded && item.link
										? `<a href="${link}" class="dhx_item--download-btn dxi dxi-download" download="${downloadName}"></a>`
										: ``
								}
								<div class="dhx_item--btn-remove dxi dxi-delete-forever"></div>
							</div>`
					}
				</div>`
		}`;
};

export const getContainersEvents = data => {
	const mouseOverFileNameHandler = event => {
		const id = locate(event);
		if (!id) {
			return;
		}
		const item = data.getItem(id);
		tooltip(item.name, {
			node: event.target,
			position: Position.bottom,
		});
	};

	return {
		onclick: {
			"dxi-delete-forever": event => {
				const id = locate(event);
				if (!id) {
					return;
				}
				removeItem(data, id);
			},
		},
		onmouseover: {
			"dxi-download": event => {
				tooltip(locale.download, {
					node: event.target,
					position: Position.bottom,
				});
			},
			"dxi-delete-forever": event => {
				tooltip(locale.clear, {
					node: event.target,
					position: Position.bottom,
				});
			},
			"dhx_list-item--name": mouseOverFileNameHandler,
			"dhx_dataview-item--file-name": mouseOverFileNameHandler,
		},
	};
};
